import { forwardRef } from 'react';
import { cx } from 'class-variance-authority';
import { Box } from './Box';
import { BaseTypeMap, Component, ComponentProps } from './types/Component';

type GridTypeMap = BaseTypeMap<'div'>;

export type GridProps = ComponentProps<GridTypeMap>;

export const Grid: Component<GridTypeMap> = forwardRef(function Grid(
  { children, className, ...rest },
  ref
) {
  return (
    <Box
      className={cx(
        'grid',
        'grid-cols-4',
        'sm:grid-cols-8',
        'md:grid-cols-12',
        'gap-4',
        'md:gap-6',
        className
      )}
      ref={ref}
      {...rest}
    >
      {children}
    </Box>
  );
});
